export const config = {
  apiKey: "AIzaSyA9ckGsnkFdTHpe1qBPdRZ-Xej4P86g4k0",
  authDomain: "pgerlipp.firebaseapp.com",
  databaseURL: "https://pgerlipp.firebaseio.com",
  projectId: "pgerlipp",
  storageBucket: "pgerlipp.appspot.com",
  messagingSenderId: "58496934921",
  appId: "1:58496934921:web:c8f807a4a4f3f0083bc4d8",
  measurementId: "G-PZ73TJKPT2"
};